"use client";

import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";

import { usePostLogout } from "@/api/auth/postLogout";
import { NAV_ITEMS } from "@/components/layout/constants";
import SideBar from "@/components/layout/Sidebar";
import { Button, TypoGraph } from "@/components/ui/primitives";
import { LogoutIcon } from "@/components/ui/primitives/icons";
import { ROUTES } from "@/config/routes/paths";

import HamburgerMenu from "./HamburgerMenu";

const Header = () => {
  const router = useRouter();
  const pathname = usePathname();
  const pathnameArray = pathname.split("/");

  const [username, setUsername] = useState<string | null>(null);
  const [isOpenSideBar, setIsOpenSideBar] = useState(false);

  const { mutate: logout } = usePostLogout();

  const onToggleSideBar = () => setIsOpenSideBar((prev) => !prev);
  const onCloseSideBar = () => setIsOpenSideBar(false);

  const handleLogout = () => {
    logout();
    localStorage.removeItem("access_token");
    localStorage.removeItem("userid");
    localStorage.removeItem("username");
    router.push(ROUTES.LOGIN);
  };

  const currentNav =
    NAV_ITEMS.find((item) => item.key === pathnameArray[1]) ?? NAV_ITEMS[0];

  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    setUsername(storedUsername);
  }, []);

  return (
    <>
      <header className="fixed top-0 w-full h-(--header-h) border-b border-gray-300 flex justify-between px-[18px] z-[1300] gap-4 items-center bg-white">
        <div className="flex items-center shrink-0 gap-3">
          <HamburgerMenu onClick={onToggleSideBar} isActive={isOpenSideBar} />
          <Link href={currentNav.href}>
            <TypoGraph variant="headline03" className="mt-[3px] text-gray-900">
              {currentNav.label}
            </TypoGraph>
          </Link>
        </div>

        <Button
          variant="text"
          size="xsmall"
          leftIcon={<LogoutIcon size={20} className="text-gray-700" />}
          onClick={handleLogout}
        >
          로그아웃
        </Button>
      </header>

      <SideBar isOpenSideBar={isOpenSideBar} onCloseSideBar={onCloseSideBar} />
    </>
  );
};

export default Header;
